import { useIntl } from 'react-intl';
import { UptimeSelect } from '../UptimeSelect';
import '../styles/tokens.scss';
import './styles.scss';

export interface IUptimePagerProps {
    page: number;
    pageSize: number;
    total: number;
    onPageChange: (page: number) => void;
    onPageSizeChange?: (pageSize: number) => void;
    pageSizes?: number[];
    className?: string;
}

export const UptimePager = ({
    page,
    pageSize,
    total,
    onPageChange,
    onPageSizeChange,
    pageSizes = [25, 50, 100],
    className,
}: IUptimePagerProps) => {
    const intl = useIntl();
    const t = (key: string, values?: Record<string, string>) =>
        intl.formatMessage({ id: `intl-msg:shared.pager.${key}` }, values);
    const format = (value: number) => value.toLocaleString(intl.locale);
    const pages = Math.max(1, Math.ceil(total / pageSize));
    const from = page * pageSize + 1;
    const to = Math.min(total, (page + 1) * pageSize);

    return (
        <div className={`upt-pager${className ? ` ${className}` : ''}`}>
            {total > 0 && (
                <span className='upt-pager__range'>
                    {t('range', { from: format(from), to: format(to), total: format(total) })}
                </span>
            )}
            {onPageSizeChange && (
                <UptimeSelect
                    label={t('pageSize')}
                    value={pageSize}
                    options={pageSizes.map(size => ({ value: size, label: size }))}
                    onChange={onPageSizeChange}
                    align='right'
                />
            )}
            <button
                type='button'
                className='upt-pager__button'
                disabled={page === 0}
                onClick={() => onPageChange(page - 1)}
            >
                ‹ {t('previous')}
            </button>
            <button
                type='button'
                className='upt-pager__button'
                disabled={page >= pages - 1}
                onClick={() => onPageChange(page + 1)}
            >
                {t('next')} ›
            </button>
        </div>
    );
};

export default UptimePager;
